// 本地环境配置
var timestamp = new Date().getTime()
module.exports = {
  title: '政小睿',
  baseUrl: '/', // 项目地址
  baseApi: '/', // 本地api请求地址,注意：如果你使用了代理，请设置成'/'
  baseWss:"ws://192.168.6.27:8081/app/",
  APPID: 'xxx',
  APPSECRET: 'xxx',
  $cdn: 'https://www.sunniejs.cn/static',
  ZqcUrl: `/index.html?time=${timestamp}#/home`,
  ZqcUrlMatterCon: `/index.html?time=${timestamp}#/matterCon`,
  ZqcUrlCompanyone: `/index.html?time=${timestamp}#/companytwo`,
}
